<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab v-if="partner.buyer && !inEditMode && $route.params.id != 0">{{
						$t('tabs.candidatesEmployees')
					}}</v-tab>
					<v-tab v-if="partner.supplier && !inEditMode && $route.params.id != 0">{{
						$t('tabs.ships')
					}}</v-tab>
					<v-tab v-if="partner.buyer && !inEditMode && $route.params.id != 0">{{
						$t('tabs.paymentContracts')
					}}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-flex xs12 md4 lg4>
										<v-card-title class="pa-2">{{ $t('titles.partnerInformations') }}</v-card-title>
									</v-flex>
									<v-flex class="d-flex justify-end">
										<v-btn
											v-if="inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-flex>
								</v-row>
								<v-row wrap>
									<!-- prvi stupac -->
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:readonly="true"
												v-model="partner.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.name"
												:errorBorder="!partnerValidation.name"
												:label="'* ' + $t('fields.name')"
											></InputField>
											<CheckBox
												:readonly="!inEditMode"
												v-model="partner.buyer"
												:label="$t('fields.buyer')"
											></CheckBox>
											<CheckBox
												:readonly="!inEditMode"
												v-model="partner.supplier"
												:label="$t('fields.supplier')"
											></CheckBox>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.oib"
												:errorBorder="!partnerValidation.oib"
												:label="$t('fields.oib')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.headquarter"
												:errorBorder="!partnerValidation.headquarter"
												:label="$t('fields.headquarter')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.business"
												:errorBorder="!partnerValidation.business"
												:label="$t('fields.business')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.contact_person"
												:errorBorder="!partnerValidation.contact_person"
												:label="$t('fields.contactPerson')"
											></InputField>
										</v-col>

										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.phone"
												:errorBorder="!partnerValidation.phone"
												:label="$t('fields.phone')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.email"
												:errorBorder="!partnerValidation.email"
												:label="'* ' + $t('fields.email')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="partner.rabat"
												:precision="2"
												:errorBorder="!partnerValidation.rabat"
												:label="$t('fields.rabat')"
											></NumberField>
										</v-col>
									</v-flex>
									<!-- drugi stupac -->
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.address"
												:errorBorder="!partnerValidation.address"
												:label="'* ' + $t('fields.address')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.postal_code"
												:errorBorder="!partnerValidation.postal_code"
												:label="$t('fields.postalCode')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="partner.city"
												:errorBorder="!partnerValidation.city"
												:label="'* ' + $t('fields.city')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="partner.country_id"
												:ajax="true"
												:data="'countries'"
												:errorBorder="!partnerValidation.country_id"
												:label="'*' + $t('fields.country')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="partner.note"
												:errorBorder="!partnerValidation.note"
												:label="$t('fields.note')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="partner.active"
												:label="$t('fields.active')"
											></CheckBox>
										</v-col>
									</v-flex>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode">
						<PartnerCandidates :partnerId="$route.params.id"> </PartnerCandidates>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode">
						<PartnerShips :partnerId="$route.params.id"></PartnerShips>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode">
						<PartnerPaymentContracts> </PartnerPaymentContracts>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import TextArea from '../../trinkets/TextArea';
import NumberField from '../../trinkets/NumberField';
import Partner from '../../../models/Partner';
import PartnerCandidates from './PartnerCandidates';
import PartnerShips from './PartnerShips';
import PartnerPaymentContracts from './PartnerPaymentContracts';

export default {
	name: 'Partner',
	components: {
		CheckBox,
		InputField,
		Dropdown,
		TextArea,
		NumberField,
		PartnerCandidates,
		PartnerShips,
		PartnerPaymentContracts,
	},
	data: function () {
		return {
			partner: new Partner({ id: this.$route.params.id }),
			partnerValidation: new Partner({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'partner',
			lockTimer: null,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.partner.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.partner.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		selectHeaders(headers) {
			this.candidatesTable.selectedHeaders = headers;
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.partner.name == null || this.partner.name == '') {
				success = false;
				this.partnerValidation.name = false;
			} else {
				if (this.partner.name.length > 100) {
					this.partnerValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '100') + '<br />';
				} else {
					this.partnerValidation.name = true;
				}
			}

			if (!this.partner.buyer && !this.partner.supplier) {
				errorMessages += this.$t('alerts.buyerOrSupplier') + '<br />';
			}

			if (this.partner.oib != null && this.partner.oib != '') {
				if (this.partner.oib.length > 20) {
					this.partnerValidation.oib = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.oib'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.partnerValidation.oib = true;
				}
			}

			if (this.partner.headquarter != null && this.partner.headquarter.length > 50) {
				success = false;
				this.partnerValidation.headquarter = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.headquarter'))
						.replace('%length%', '50') + '<br />';
			} else {
				this.partnerValidation.headquarter = true;
			}

			if (this.partner.business != null && this.partner.business.length > 100) {
				this.partnerValidation.business = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.business'))
						.replace('%length%', '100') + '<br />';
			} else {
				this.partnerValidation.business = true;
			}

			if (this.partner.phone != null && this.partner.phone.length > 30) {
				this.partnerValidation.phone = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.phone'))
						.replace('%length%', '30') + '<br />';
			} else {
				this.partnerValidation.phone = true;
			}

			if (this.partner.email == null || this.partner.email == '') {
				success = false;
				this.partnerValidation.email = false;
			} else {
				if (!this.$checkEmail(this.partner.email)) {
					this.partnerValidation.email = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('E-mail') + '<br />';
				} else {
					this.partnerValidation.email = true;
				}
			}

			if (
				this.partner.rabat != null &&
				this.partner.rabat != 0 &&
				(this.partner.rabat < 0.01 || this.partner.rabat > 100)
			) {
				this.partnerValidation.rabat = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.rabat'))
						.replace('%min%', '0.01')
						.replace('%max%', '100') + '<br />';
			} else {
				this.partnerValidation.rabat = true;
			}

			if (this.partner.address == null || this.partner.address == '') {
				success = false;
				this.partnerValidation.address = false;
			} else {
				if (this.partner.address.length > 100) {
					this.partnerValidation.address = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.address'))
							.replace('%length%', '100') + '<br />';
				} else {
					this.partnerValidation.address = true;
				}
			}

			if (this.partner.postal_code != null && this.partner.postal_code.length > 20) {
				this.partnerValidation.postal_code = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.postalCode'))
						.replace('%length%', '20') + '<br />';
			} else {
				this.partnerValidation.postal_code = true;
			}

			if (this.partner.city == null || this.partner.city == '') {
				success = false;
				this.partnerValidation.city = false;
			} else {
				if (this.partner.city.length > 50) {
					this.partnerValidation.city = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.city'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.partnerValidation.city = true;
				}
			}

			if (!this.partner.country_id || this.partner.country_id == '') {
				success = false;
				this.partnerValidation.country_id = false;
			} else {
				this.partnerValidation.country_id = true;
			}

			if (this.partner.note != null && this.partner.note.length > 2000) {
				success = false;
				this.partnerValidation.note = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.note'))
						.replace('%length%', '2000') + '<br />';
			} else {
				this.partnerValidation.note = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.partner.id != 0) {
					action = 'put';
					addition = '/' + vm.partner.id;
				}
				this.$APICall(action, 'partners' + addition, this.partner, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.partner.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.partner.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.partner.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.partner.id != 0) {
			this.$APICall('get', 'partners/' + this.partner.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.partner = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.partners'),
							href: '/#/partners',
							disabled: false,
						},
						{
							text: vm.partner.name + ' (' + vm.partner.id + ')',
							href: '/#/partners/' + vm.partner.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.partners'),
					href: '/#/partners',
					disabled: false,
				},
				{
					text: this.$t('modules.newPartner'),
					href: '/#/partners/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
